<template>
   <form-dialog v-if="$can({ assessment: 'write' })"
    name=""
    icon="person_add"
    :steps="$filterByEntitlements(formSteps)"
    editable-company large-btn
    @submit="create"
    data-test="createAccounts"
  />
</template>

<script>
import FormDialog from '@/components/FormDialog'
import UsersCollection from '@/modules/Accounts/models/Users.collection'
import AccountInfoForm from './FormSteps/AccountInfo'
import AccountScheduling from './FormSteps/AccountScheduling'
import AccountAssessmentConfig from './FormSteps/AccountAssessmentConfig'
import AccountReviewForm from './FormSteps/AccountReview'
import { Bus } from '@/bus'

export default {
  name: 'CreateAccounts',
  props: {
    accounts: Array,
    onUpdate: Function,
    disabled: Boolean
  },
  components: {
    FormDialog
  },
  data () {
    return {
      formSteps: [
        { name: 'Credentials', component: AccountInfoForm, editable: true, $can: { assessment: 'write' } },
        { name: 'Assessment Config', component: AccountAssessmentConfig, editable: true, $can: { assessment: 'write' } },
        { name: 'Scheduling', component: AccountScheduling, editable: true, $can: { assessment: 'write' } },
        { name: 'Review', component: AccountReviewForm, editable: true }
      ]
    }
  },
  methods: {
    /**
     * Function triggered on submission of the FormDialog: create accounts
     *
     * @param data      data submitted from the form
     * @param success   callback to FormDialog: called when accounts creation succeeds
     * @param error     callback to FormDialog: called when accounts creation fails
     */
    create ({ data, success, error }) {
      this.$store.dispatch('accounts/createAccounts', data)
        .then((users) => {
          const count = users.length

          success()
          Bus.$emit('alert', { color: 'success', message: `${count} new account${count === 1 ? '' : 's'} created` })

          // Generate and download csv file if csv uploader used
          if (data.csv.filename !== null) {
            const usersCollection = new UsersCollection(users)

            usersCollection.generateCsvFromCreate(data.csv)
              .then(csvFile => {
                csvFile.download()
              })
              .catch(error => {
                Bus.$emit('alert', { color: 'error', message: error })
              })
          }
        })
        .catch((err) => {
          error()
          Bus.$emit('alert', { color: 'error', message: err })
        })
    }
  }
}
</script>
